import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findNotifications = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_MESSAGING_API_URL}/notifications${query}`,
    {
      headers,
    },
  );
};

export const findNotificationById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MESSAGING_API_URL}/notifications/${id}`,
    {
      headers,
    },
  );
};

export const deleteNotification = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_MESSAGING_API_URL}/notifications/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteNotifications = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_MESSAGING_API_URL}/notifications?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
